"use client";

import { Announcement, Config, Template } from "src/types";
import { useTheme } from "../../contexts/useTheme";

// ✅ Manual imports
import AnnouncementDesign1 from "../design1/AnnouncementPage";
import AnnouncementDesign2 from "../design2/AnnouncementPage";
import AnnouncementDesign3 from "../design3/Pages/AnnouncementPage";

type BlogSwitchProps = {
  serverConfig: Config;
  blogPosts: Announcement[];
};

const BlogSwitch = ({ serverConfig, blogPosts }: BlogSwitchProps) => {
  const isDemo = process.env.NEXT_PUBLIC_DEMO_MODE === "true";
  const { config } = useTheme();

  const template: Template | undefined = isDemo
    ? config?.template
    : serverConfig.template;

  let SelectedComponent;

  switch (template) {
    case "design1":
      SelectedComponent = AnnouncementDesign1;
      break;
    case "design2":
      SelectedComponent = AnnouncementDesign2;
      break;
    default:
      SelectedComponent = AnnouncementDesign3;
      break;
  }

  return (
    <SelectedComponent
      announcements={blogPosts}
      
    />
  );
};

export default BlogSwitch;
